import SectionHead from './SectionHead'

const SCOUT = {
  name: 'Scout',
  role: 'Guide',
  stages: 'Stages 1, 2 and 5',
  cap: 'bg-scout',
  text: 'text-scout',
  description:
    'Introduces the team to AI, strengths and weaknesses and all. Runs workflow discovery, holds the vote, and comes back at the end to package the playbook.',
  insight: 'AI works better once everyone knows what it cannot do.',
}

const SPECIALISTS = [
  {
    name: 'Archivist',
    role: 'Analyst',
    stages: 'Stage 3',
    cap: 'bg-archivist',
    text: 'text-archivist',
    description:
      'Reads the docs you already have and asks the awkward questions. The team fills the gaps so the AI has something to work from.',
    insight: 'Most AI failures trace back to vague documentation, not bad prompts.',
  },
  {
    name: 'Builder',
    role: 'Engineer',
    stages: 'Stage 4',
    cap: 'bg-builder',
    text: 'text-builder',
    description:
      'Turns that documentation into working instructions. You test them against real cases and keep editing until they hold.',
    insight: 'Good prompts are iterated, not written. Test, fail, learn, repeat.',
  },
]

export default function AgentShowcaseSection() {
  return (
    <section className="bg-surface py-14 md:py-16 border-y-2 border-navy">
      <div className="mktg-container">
        <SectionHead
          mark="SECT. 03"
          title="Your three AI teammates"
          note="Each one has a narrow job, and each hands off to the next in writing."
        />

        <div className="grid lg:grid-cols-[1.15fr_1fr] gap-6 items-start">
          {/* Featured: the agent you meet first and last. */}
          <article className="card card-shadow">
            <div className={`${SCOUT.cap} h-2.5 border-b-2 border-navy`} />
            <div className="p-6 md:p-7">
              <div className="flex items-baseline gap-3 mb-1">
                <h3 className="hl text-3xl md:text-4xl">{SCOUT.name}</h3>
                <span className={`mono-label ${SCOUT.text}`}>{SCOUT.role}</span>
              </div>
              <p className="mono-label text-navy/70 mb-4">{SCOUT.stages}</p>
              <p className="text-navy/80 leading-relaxed mb-5">{SCOUT.description}</p>
              <p className="descriptor text-navy/70 border-t-2 border-navy pt-3">
                {SCOUT.insight}
              </p>
            </div>
          </article>

          <div className="grid gap-6">
            {SPECIALISTS.map((agent) => (
              <article key={agent.name} className="card card-shadow">
                <div className={`${agent.cap} h-2 border-b-2 border-navy`} />
                <div className="p-5 md:p-6">
                  <div className="flex items-baseline gap-3 mb-1">
                    <h3 className="font-display text-xl text-navy">{agent.name}</h3>
                    <span className={`mono-label ${agent.text}`}>{agent.role}</span>
                    <span className="mono-label text-navy/70 ml-auto">{agent.stages}</span>
                  </div>
                  <p className="text-navy/75 text-sm leading-relaxed mb-4">{agent.description}</p>
                  <p className="descriptor text-sm text-navy/70 border-t border-navy/25 pt-2.5">
                    {agent.insight}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
